import axios from './config.service';

export interface HtmlType {
  htmlHeader: string;
  htmlBody: string;
  htmlFooter: string;
}

export class ConvertHTMLService {
    static async convertHTML (fields: HtmlType) {
        try {
          const res: any = await axios.post("convert/convert-html-to-word", fields, {responseType: 'blob'});
          if (res.status !== 200) return;
          return res;
        } catch (error: any) {
          console.log(error);
        }
      }
}